// extracted by mini-css-extract-plugin
module.exports = {"faqList":"FaqList_faqList__NBIlv","faqs":"FaqList_faqs__4M5GA","faqTitle":"FaqList_faqTitle__vs5Sk","sectionTitle":"FaqList_sectionTitle__SFvhA"};